import Image from 'next/image'
import { useState, useEffect, useRef } from 'react'
import {
  Icons,
  ContentWrapper,
  DesktopLogo,
  BodySpacer,
  TopbarContainer,
  CartIcon,
  Total,
} from './BookingEngineTopbar.styles'
import Icon from './Icons'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useTheme } from 'styled-components'
import { useDefaultProperties } from '@/hooks/DefaultPropertiesHook'
import { useCart } from '@big-red-group/storefront-common-checkout'
import { getUrlPrefix } from '@/helpers/UrlHelper'

const BookingEngineTopbar = () => {
  const router = useRouter()
  const theme = useTheme()
  const defaultProperties = useDefaultProperties()
  const agentConfiguration = defaultProperties?.agentConfiguration
  const baseUrl = getUrlPrefix(agentConfiguration?.handlerKey)
  const { lang } = router.query
  const { data: cart } = useCart('cart', baseUrl)
  const total = cart?.items?.length || 0

  const topbarRef = useRef<HTMLInputElement>(null)
  const [topbarHeight, setTopbarHeight] = useState(0)
  useEffect(() => {
    if (topbarRef.current !== null) {
      setTopbarHeight(topbarRef.current.clientHeight)
    }
  }, [])

  return (
    <>
      <TopbarContainer ref={topbarRef} id="top-bar-wrapper">
        <ContentWrapper>
          {/* TODO: conditionally render based on products.length */}
          <Link href={`/${router.query.lang}`}>Home</Link>
          <Link href={agentConfiguration?.homeSiteUrl || `/${lang}`}>
            <DesktopLogo showOnMobile>
              <Image
                src={theme?.logo?.image ? theme.logo.image : '/logos/exoz-logo.svg'}
                alt="Experience Oz"
                width={140}
                height={70}
              />
            </DesktopLogo>
          </Link>

          <Icons>
            {/* cart */}
            <Link href="/en/order/checkout">
              <CartIcon>
                {total > 0 && <Total>{total}</Total>}
                <Icon name="shoppingBag" />
              </CartIcon>
            </Link>
          </Icons>
        </ContentWrapper>
      </TopbarContainer>
      <BodySpacer height={topbarHeight} />
    </>
  )
}

export default BookingEngineTopbar
